"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingToolbar = void 0;
const react_1 = __importStar(require("react"));
const ItalicButton_1 = __importDefault(require("./Tools/Italic/ItalicButton"));
const UnderlineButton_1 = __importDefault(require("./Tools/Underline/UnderlineButton"));
const BoldButton_1 = __importDefault(require("./Tools/Bold/BoldButton"));
const hooks_1 = require("../hooks");
const RemoveLinkButton_1 = __importDefault(require("./Tools/Link/RemoveLinkButton"));
const LinkButton_1 = __importDefault(require("./Tools/Link/LinkButton"));
const react_2 = require("@remirror/react");
const react_components_1 = require("@remirror/react-components");
const createToolbarPositioner_1 = require("../utils/createToolbarPositioner");
const ImageButton_1 = __importDefault(require("./Tools/Image/ImageButton"));
const Extensions_1 = require("../Extensions/Extensions");
const ClearFormattingButton_1 = __importDefault(require("./Tools/ClearFormatting/ClearFormattingButton"));
const FloatingToolbar = () => {
    const watchedMarks = [Extensions_1.MarkName.Link, Extensions_1.MarkName.AssetLink];
    const extensionNames = (0, hooks_1.useExtensionNames)();
    const positioner = (0, react_1.useMemo)(() => (0, createToolbarPositioner_1.createToolbarPositioner)({ types: watchedMarks }), []);
    const { clearFormatting } = (0, react_2.useCommands)();
    const active = (0, react_2.useActive)();
    const { data: { marks }, } = (0, react_2.usePositioner)(positioner, []);
    let buttons = [
        extensionNames.bold && react_1.default.createElement(BoldButton_1.default, { key: "bold" }),
        extensionNames.italic && react_1.default.createElement(ItalicButton_1.default, { key: "italic" }),
        extensionNames.underline && react_1.default.createElement(UnderlineButton_1.default, { key: "underline" }),
    ];
    if (active.image() || active.assetImage() || active.DAMImage()) {
        buttons = [react_1.default.createElement(ImageButton_1.default, { key: "add-image", inPopover: true })];
    }
    else if (marks?.[Extensions_1.MarkName.Link].isExclusivelyActive || marks?.[Extensions_1.MarkName.AssetLink].isExclusivelyActive) {
        // if all of the selected text is a link show the options to update/remove the link instead of the regular
        // formatting options.
        buttons = [
            react_1.default.createElement(LinkButton_1.default, { key: "update-link", inPopover: true }),
            react_1.default.createElement(RemoveLinkButton_1.default, { key: "remove-link", inPopover: true }),
        ];
    }
    else if (!marks?.[Extensions_1.MarkName.Link].isActive && !marks?.[Extensions_1.MarkName.AssetLink].isActive) {
        // if none of the selected text is a link show the option to create a link.
        buttons.push(react_1.default.createElement(react_components_1.VerticalDivider, { key: "link-divider" }), react_1.default.createElement(LinkButton_1.default, { key: "add-link", inPopover: true }));
    }
    // Clear formatting will always be the last button in the toolbar
    if (extensionNames.clearFormatting && clearFormatting.enabled()) {
        buttons.push(react_1.default.createElement(ClearFormattingButton_1.default, { key: "clearFormatting" }));
    }
    return (react_1.default.createElement(react_2.FloatingToolbar, { className: "squiz-fte-scope squiz-fte-scope__floating-popover", positioner: positioner, tabIndex: 0, role: 'toolbar' }, buttons));
};
exports.FloatingToolbar = FloatingToolbar;
